<div id="knightmeds" [class.black-cabinet]="cabinetColor() === 'black'">
  @for (row of drawerRows; track $index) {
  <div class="row">
    @for (id of row; track id) {
    <span class="drawer" [class.highlighted]="highlightedContainerId() === id"
      (click)="onContainerClicked.emit(id)">
      @if (containerLabels() != undefined) {
      <div class="label">
        {{containerLabels()![id]}}
      </div>
      }
      @if (containerWarnings() != undefined) {
      <div class="warning">
        {{containerWarnings()![id]}}
      </div>
      }
    </span>
    }
  </div>
  }
</div>
